import React, { useState, useEffect } from "react";
import Header from "../shared/header/Header";
import NavigationManu from "../shared/navigationMenu/NavigationMenu";
import PageHeader from "../shared/pageHeader/PageHeader";
import LeadsStatistics from "../widgetsStatistics/LeadsStatistics";
import InquiryTrackingChart from "../widgetsCharts/InquiryTrackingChart";
import InquiryChannelChart from "../widgetsCharts/InquiryChannelChart";
import LeadsStatusTwo from "../widgetsTables/LeadsStatusTwo";
import ProjectLeads from "../widgetsList/ProjectLeads";
import Footer from "../shared/Footer";
import { fetchFormData } from "../../utils/options";
import { useNavigate, useLocation } from "react-router-dom";
import { inquiryTrackingChartOption } from "../../utils/chartsLogic/inquiryTrackingChartOption";
const Reports = () => {
  const [leads, setLeads] = useState([]);
  const [permission, setPermission] = useState({});
  const [leadSummary, setLeadSummary] = useState([]);
  const [chartOptions, setChartOptions] = useState({});

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    const getPermission = async () => {
      const roleId = localStorage.getItem("roleId");
      const M_id = queryParams.get("id");

      const formData = new FormData();
      formData.append("role_id", roleId);
      formData.append("module_id", M_id || 1);

      try {
        const result = await fetchFormData("get-permission", formData, "POST");
        const perm = result?.data;

        setPermission(perm);
      } catch (error) {
        console.error("Error fetching permission", error);
      }
    };

    getPermission();
  }, [M_id]);

  const fetchAllData = async () => {
    const userId = localStorage.getItem("id");

    const formData = new FormData();
    formData.append("userId", userId);

    try {
      const dashboardData = await fetchFormData(
        "dashboard-leads",
        formData,
        "POST"
      );
      // Dashboard data handling
      if (dashboardData?.code === 200) {
        const summary = dashboardData?.data?.lead_summary || [];
        const data = dashboardData?.data;

        const { latest_lead = [] } = data;
        const { upcoming_followups = [] } = data;

        // setFollowup(upcoming_followups);
        setLeads(latest_lead);
        setLeadSummary(summary);
        // setOverviewInfo(data.summary_counts);
        setChartOptions(inquiryTrackingChartOption(summary));
        // SetInquiry(data.inquiry_summary);
      }
    } catch (error) {
      console.error("Failed to fetch dashboard or permissions:", error);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  return (
    <>
      <Header />
      <NavigationManu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader></PageHeader>
          <div className="main-content">
            <div className="row">
              <LeadsStatistics
                leadSummary={leadSummary}
                permission={permission}
              />
            </div>
            <div className="row">
              <InquiryChannelChart permission={permission}/>
              <LeadsStatusTwo leads={leads} permission={permission} />
            </div>
            {/* <InquiryTrackingChart
                chartOptions={chartOptions}
                leadSummary={leadSummary}
                permission={permission}
              /> */}

            {/* <ProjectLeads /> */}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};
export default Reports;
